import {DictWeapon} from "../../../../model/Dto/Dict/Weapon";
import {ApiRequest, RequestMethod} from "../../../request";

export async function getWeaponById(id: string): Promise<DictWeapon | null> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.GET);
    apiRequest.setUrl(`/api/weapon/${id}`);
    const response: any = await apiRequest.send();
    if (response.status === 200) return response.data;
    return null;
}